export default __webpack_public_path__ + "static/Giant_Metal_Trapdoor-1194a4b3849a95d5f85947f797e585be.png";